import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Switch, Typography } from '@mui/material';

import { useSettingsSelector, setGoogleImagePull } from '../../store/settings';

import './styles.scss';

const GoogleImageSwitch = ({ onEditMode }) => {
  const dispatch = useDispatch();
  const { isGoogleImagePull } = useSettingsSelector();

  const onGoogleImagePullChange = useCallback(
    () => dispatch(setGoogleImagePull(!isGoogleImagePull)),
    [dispatch, isGoogleImagePull]
  );

  return (
    <div className="switch-row">
      <div className="switch-text-wrapper">
        <Typography className="switch-label">{'Google Image Pull'}</Typography>
        <Typography className="switch-description">
          {
            'Enable Google Street View fallback when no location-specific photos exist'
          }
        </Typography>
      </div>

      <Switch
        className={'custom-switch'}
        disabled={!onEditMode}
        checked={isGoogleImagePull}
        onChange={onGoogleImagePullChange}
      />
    </div>
  );
};

GoogleImageSwitch.propTypes = {
  onEditMode: PropTypes.bool.isRequired
};

export default GoogleImageSwitch;
